function normalizeValue(value) {
  if (Array.isArray(value)) {
    return value.map(normalizeValue);
  }

  if (value && typeof value === 'object') {
    return Object.keys(value)
      .sort()
      .reduce((normalized, key) => {
        normalized[key] = normalizeValue(value[key]);
        return normalized;
      }, {});
  }

  return value;
}

function parsePayload(payload) {
  if (typeof payload !== 'string') {
    return payload || {};
  }

  try {
    return JSON.parse(payload);
  } catch {
    return { rawPayload: payload };
  }
}

function getHistoryChangeIdentity(change = {}) {
  const payload = parsePayload(change.payload);

  return JSON.stringify(
    normalizeValue({
      changedBy: change.changed_by ?? null,
      created: change.created ?? null,
      field: change.field ?? null,
      filename: payload.filename ?? null,
      newValue: payload.new_value ?? null,
      note: payload.note ?? null,
      oldValue: payload.old_value ?? null,
      rawPayload: payload.rawPayload ?? null,
      status: payload.status ?? null,
      title: payload.title ?? null,
    })
  );
}

export function mergeUniqueHistoryChanges(existingChanges, incomingChanges) {
  const mergedChanges = [...existingChanges];
  const knownChanges = new Set(existingChanges.map(getHistoryChangeIdentity));

  incomingChanges.forEach((change) => {
    const identity = getHistoryChangeIdentity(change);

    if (!knownChanges.has(identity)) {
      knownChanges.add(identity);
      mergedChanges.push(change);
    }
  });

  return mergedChanges;
}
